// IE9 don't implement it
if(!("cancelAnimationFrame" in window)){
	if("webkitCancelAnimationFrame" in window){
		window.cancelAnimationFrame = window.webkitCancelAnimationFrame;
	}else{
		window.cancelAnimationFrame = function cancelAnimationFrame(requestID) {
			window.clearTimeout(requestID);
		};
	}
}